import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../../../components/Button";
import { SetPasswordLayout } from "../../../layout/components/SetPasswordLayout";
import { authService } from "../../../services/authService";
import {
  buttonCss,
  InfoMessage,
  MainContainer,
  TitleMessage,
} from "./InvalidPassLinkPage.styles";

interface IInvalidPassLinkPageProps {
  email: string | null;
  isPatient: boolean;
}

export function InvalidPassLinkPage({
  email,
  isPatient,
}: IInvalidPassLinkPageProps) {
  const { t } = useTranslation();
  const isSubmittingRef = useRef(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessMessage, setShowSucessMessage] = useState(false);

  const handleRequestNewLink = async () => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;

    setIsLoading(true);
    if (email) {
      try {
        if (isPatient) {
          await authService.sendPatientForgotPasswordRequest({ email });
        } else {
          await authService.sendStaffForgotPasswordRequest({ email });
        }
      } finally {
        setIsLoading(false);
        setShowSucessMessage(true);
        isSubmittingRef.current = false;
      }
    } else {
      isSubmittingRef.current = false;
    }
  };

  return (
    <SetPasswordLayout>
      <MainContainer>
        {!showSuccessMessage ? (
          <>
            <TitleMessage>{t("setPassword_invalid_title")}</TitleMessage>
            <InfoMessage>{t("setPassword_invalid_reason")}</InfoMessage>
            <InfoMessage>{t("setPassword_invalid_requestPrompt")}</InfoMessage>
            <Button
              isLoading={isLoading}
              className={buttonCss()}
              label={t("setPassword_invalid_requestButton")}
              onClick={handleRequestNewLink}
              type="button"
            />
          </>
        ) : (
          <>
            <TitleMessage>{t("setPassword_sent_title")}</TitleMessage>
            <InfoMessage>{t("setPassword_sent_body", { email })}</InfoMessage>
            <InfoMessage>{t("setPassword_sent_instructions")}</InfoMessage>
          </>
        )}
      </MainContainer>
    </SetPasswordLayout>
  );
}
